import { GROUP_BY_ROUTE_PATH, GROUP_BY_URL, GROUP_BY_ROUTE_PATH_WE_CHAT } from './white-list-url-map';
export default {
  /**
   * 根据url将异常分类
   * @param url 接口url
   */
  getModuleName(url) {
    if (url === '/sso/logoutDecide' || url === '/auth/oauth/token') return '基础组';
    if (
      new RegExp(`.*/(auth|notification|push|report|mobile|supplier)/api/.*`).test(url) ||
      new RegExp(`^/wechat-service/.*`).test(url)
    )
      return '基础组';
    if (new RegExp(`.*/brms/api/.*`).test(url)) return '申请单组';
    if (new RegExp(`.*/(custom-printing|receipt|budget-service|invoice)/api/.*`).test(url)) return '报销单组';
    if (new RegExp(`.*/(payment|ledger|contract)/api/.*`).test(url)) return '财务组';
    if (
      new RegExp(`.*/(vendor-info-service|location-service)/api/.*`).test(url) ||
      new RegExp(`.*/open/.*/api/.*`).test(url)
    )
      return '消费平台';
    if (new RegExp(`.*/e-archives/api/.*`).test(url)) return 'E档案';

    let moduleName = '其他';
    Object.keys(GROUP_BY_URL).map((group) => {
      GROUP_BY_URL[group].find((rule) => {
        return new RegExp(`.*/api/${rule}/.*`).test(url) || new RegExp(`.*/api/${rule}$`).test(url);
      }) && (moduleName = group);
    });
    return moduleName;
  },
  getModuleNameByRoutesPath(url, isWeChat = false) {
    let moduleName = '其他';
    Object.keys(isWeChat ? GROUP_BY_ROUTE_PATH_WE_CHAT : GROUP_BY_ROUTE_PATH).some((group) => {
      let find = false;
      (isWeChat ? GROUP_BY_ROUTE_PATH_WE_CHAT : GROUP_BY_ROUTE_PATH)[group].some((rule) => {
        return new RegExp(`^${rule}/.*`).test(url) || new RegExp(`^${rule}$`).test(url);
      }) && ((moduleName = group), (find = true));
      if (find) return true;
    });
    return moduleName;
  },
  getExceptionCategory({ url, error: _error, reqParams }) {
    const error = _error?.response && _error.response.status ? _error.response : _error;
    if (error?.data?.exceptionCategory) return error.data.exceptionCategory;
    if (
      [
        'EvalError',
        'RangeError',
        'ReferenceError',
        'SyntaxError',
        'TypeError',
        'URIError',
        'AggregateError',
        'InternalError',
      ].includes(_error?.constructor.name)
    )
      return 'FRONTEND_ERR';
    if (typeof error === 'string') {
      return 'BIZ_ERR';
    } else if (typeof error?.data === 'string' && !error?.status) {
      return 'BIZ_ERR';
    } else if (typeof error?.data === 'string' && error.data.indexOf('<html>') > -1) {
      return 'SERVER_ERR';
    } else if (typeof error === 'object' && !Array.isArray(error)) {
      const { data: { code } = {}, status } = error;
      const moduleName = this.getModuleName(url);
      if (!['财务组'].includes(moduleName) && status && status > 404) {
        return 'SERVER_ERR';
      } else if (status && status > 500) {
        return 'SERVER_ERR';
      } else if ([500, 504, 5100, 5101, 5102, 5103, 5104, 404, 4105, 4001, 4002, 4003].includes(code)) {
        return 'SERVER_ERR';
      } else if (!status || [404, 400, 200, 401].includes(status) || [5500].includes(code)) {
        return 'BIZ_ERR';
      }
    }
  },
  getErrorMessage(error) {
    if (!error) return '';
    let errorMessage = '';
    let errorData = Object.assign({}, (error || {}).data || {});
    // 处理 errorData 为非对象的情况
    if (typeof errorData != 'object') {
      const _errorData = errorData;
      errorData = {
        message: _errorData,
      };
    }

    const { message, validationErrors, failReason } = errorData;
    let validationError = '';
    errorMessage = message || '';
    // 处理validationErrors
    if (validationErrors && (validationError = validationErrors[0])) {
      errorMessage += `:${(validationError || {}).message}`;
    }
    // 处理failReasons
    if (failReason) {
      const failReasonAry = [];
      for (const key in failReason) {
        failReasonAry.push(`${key}:${failReason[key]}`);
      }
      errorMessage += `:${failReasonAry.join(',')}`;
    }
    errorData.message = errorMessage;
    return errorMessage;
  },
  isStageEnv() {
    const hostname = location.hostname;
    return /^(stage|archive-stage|appcorestage|dingtalkstage).*\.huilianyi\.com$/.test(hostname);
  },
  shouldReportData(companyConfig = {}) {
    if (this.isStageEnv()) return true; // stage环境 始终上报 不用读取配置
    const { reportEventMonitorData = true } = companyConfig;
    if (!reportEventMonitorData) return false;
    return true;
  },
  getPureUrl(url) {
    const urlParseReg = /[^\/](\/[^\/][^\?]+)/;
    if (url.startsWith('http')) {
      url = url.match(urlParseReg)[1];
    } else if (url.indexOf('?') !== -1) {
      if (/\?.*(corporateFlag=true).*/.test(url)) {
        url = url.replace(/\?.*(corporateFlag=true).*/, (target, $1) => '?' + $1);
      } else {
        url = url.split('?')[0];
      }
    }
    const OIDReg = new RegExp('[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}', 'g');
    const IDReg = new RegExp('[0-9]{10,20}', 'g');
    const IDReg2 = /\/\d+$/;

    const forwardUrlReg = /^\/(v1|proxy|isg|osg)/;
    const urlRegList = [
      /\/location-service\/api\/vendor\/aliases\/(\w+\/[A-Z\d]{12})/g,
      /\/mobile\/api\/management\/widget\/tenant\/(\w+)/g,
      /\/api\/suppliers\/(\d+)/g,
    ];
    if (url.match(forwardUrlReg)) {
      url = url.replace(forwardUrlReg, '');
    }
    if (url.match(OIDReg)) {
      url = url.replace(OIDReg, '{oid}');
    }
    if (url.match(IDReg)) {
      url = url.replace(IDReg, '{id}');
    }
    if (url.match(IDReg2)) {
      url = url.replace(IDReg2, '{id}');
    }
    urlRegList.forEach((reg) => url.match(reg) && (url = url.replace(reg, (target, $1) => target.replace($1, '{id}'))));

    return url;
  },
};
